import apiClient from '@u/apiClient'
import CreateDossierFragmentController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CreateDossierFragmentController'
import FetchDossierFunebraController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierFunebraController'
import CreateDossierFunebraController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CreateDossierFunebraController'
import FetchDossierCybilleController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierCybilleController'
import CreateDossierCybilleController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CreateDossierCybilleController'
import FetchDossierIAssureController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierIAssureController'
import CreateDossierIAssureController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CreateDossierIAssureController'
import FetchDossierSorenirController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierSorenirController'
import CreateDossierSorenirController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CreateDossierSorenirController'
import FetchDossierFuneUpController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierFuneUpController'
import CreateDossierFuneUpController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CreateDossierFuneUpController'
import SendPhotoToFuneUpController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/SendPhotoToFuneUpController'
import SendDocumentToFuneUpController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/SendDocumentToFuneUpController'
import FetchDossierStoneManagerController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierStoneManagerController'
import CreateDossierStoneManagerController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CreateDossierStoneManagerController'
import FetchDossierEnaosController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierEnaosController'
import UpdateDossierEnaosOnlineController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/UpdateDossierEnaosOnlineController'
import FetchDossierEnaosTicketController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierEnaosTicketController'
import CreateDossierEnaosController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CreateDossierEnaosController'
import UpdateDossierEnaosController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/UpdateDossierEnaosController'
import SendDossierAttachmentToEnaosController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/SendDossierAttachmentToEnaosController'
import GetDossierEnaosSalesExportController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/GetDossierEnaosSalesExportController'
import FetchDossierLegacioController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierLegacioController'
import CreateDossierLegacioController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CreateDossierLegacioController'
import UpdateDossierLegacioController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/UpdateDossierLegacioController'
import SendDocumentToLegacioController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/SendDocumentToLegacioController'
import FetchDossierMesangePrevoyanceController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierMesangePrevoyanceController'
import CreateDossierMesangePrevoyanceController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/CreateDossierMesangePrevoyanceController'
import EnaosController from '@/wayfinder/actions/App/Http/Controllers/Partners/EnaosController'
import UpdateTaskDossierController from '@/wayfinder/actions/App/Http/Controllers/TaskDossier/UpdateTaskDossierController'
import { apiPath } from '@u/apiPath'
import FetchDossierFragmentController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierFragmentController'
import FetchDossierFragmentInformationsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierFragmentInformationsController'
import FetchDossierEnaosStatusController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Partners/FetchDossierEnaosStatusController'
import UpdateTaskDossierStatusController from '@/wayfinder/actions/App/Http/Controllers/TaskDossier/UpdateTaskDossierStatusController'

// const base_errors = { deceased: {}, events: [] }
const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // #region fetch
  fetchPartnerData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `/api/partners/fetch-${payload.partner}/${payload.dossier_id}`,
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // #endregion
  // #region fragment
  fetchFragment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierFragmentController['/api/dossier/{dossier}/fragment'].get(
            { dossier: payload.dossier_id },
            { query: { 'force-reload': payload.force_reload } }
          )
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchFragmentInformations({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierFragmentInformationsController.get(
            { dossier: payload.dossier_id },
            { query: { 'force-reload': payload.force_reload } }
          )
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createFragment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateDossierFragmentController.post({ dossier: payload.dossier_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchFunebra({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierFunebraController['/api/dossier/{dossier}/funebra'].get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createFunebra({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateDossierFunebraController.post({ dossier: payload.dossier_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchCybille({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierCybilleController['/api/dossier/{dossier}/cybille'].get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createCybille({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateDossierCybilleController.post({ dossier: payload.dossier_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchIAssure({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierIAssureController.get({ dossier: payload.dossier_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  saveIAssure({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateDossierIAssureController.post({ dossier: payload.dossier_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchSorenir({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierSorenirController['/api/dossier/{dossier}/sorenir'].get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createSorenir({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateDossierSorenirController.post({ dossier: payload.dossier_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchFuneUp({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierFuneUpController['/api/dossier/{dossier}/funeup'].get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createFuneUp({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateDossierFuneUpController.post({ dossier: payload.dossier_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  sendPhotoToFuneUp({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SendPhotoToFuneUpController.post({ dossier: payload.dossier_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  sendDocumentToFuneUp({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SendDocumentToFuneUpController.post({
            dossier: payload.dossier_id,
            media: payload.media_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchStoneManager({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierStoneManagerController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createStoneManager({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateDossierStoneManagerController.post({
            dossier: payload.dossier_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchEnaos({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierEnaosController['/api/dossier/{dossier}/enaos'].get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchEnaosStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierEnaosStatusController.get(
            { dossier: payload.dossier_id },
            { query: { 'force-reload': payload.force_reload } }
          )
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateEnaosStatusOnline({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierEnaosOnlineController.put({
            dossier: payload.dossier_id
          }),
          {
            is_online: payload.is_online
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchEnaosTicket({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierEnaosTicketController.get({
            funeral_home: payload.funeral_home_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createEnaos({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateDossierEnaosController.post({ dossier: payload.dossier_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateEnaos({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierEnaosController.put({ dossier: payload.dossier_id }),
          payload.data,
          {
            params: { force_update: payload.force_update || false }
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  sendDocumentToEnaos({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SendDossierAttachmentToEnaosController.post({
            dossier: payload.dossier_id,
            media: payload.media_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchEnaosSalesExport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDossierEnaosSalesExportController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  /*
          LEGACIO
   */
  fetchLegacio({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierLegacioController['/api/dossier/{dossier}/legacio'].get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createLegacio({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateDossierLegacioController.post({ dossier: payload.dossier_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateLegacio({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierLegacioController.put({ dossier: payload.dossier_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  sendDocumentToLegacio({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SendDocumentToLegacioController.post({ dossier: payload.dossier_id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  /*
        MESANGE PREVOYANCE
   */
  fetchMesangePrevoyance({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDossierMesangePrevoyanceController.get({
            dossier: payload.dossier_id
          }),
          {
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createMesangePrevoyance({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateDossierMesangePrevoyanceController.post({
            dossier: payload.dossier_id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  submitPartnerData({ commit }, obj) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(apiPath(obj.path), obj.partnerData)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updatePartnerData({ commit }, obj) {
    return new Promise((resolve, reject) => {
      apiClient
        .put(apiPath(obj.path), obj.partnerData)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async submitDocumentToEnaos({ commit }, obj) {
    commit('auth/setErrors', {}, { root: true })
    await apiClient
      .route(
        EnaosController.sendAttachment.post({ dossier: obj.dossier_id }),
        obj
      )
      .then(async (response) => {
        console.log('response', response)
        if (response.status === 201) {
          if (obj.successCallback) {
            obj.successCallback()
          }
        }
      })
      .catch(async (reason) => {
        await commit('setErrors', reason)
      })
  },

  // #endregion

  // #region update

  async updateDossierTask({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        UpdateTaskDossierController.put({ task_dossier: payload.id }),
        payload.task
      )
      .then(async (response) => {
        if (response.status === 200) {
          if (!payload.dontCommit) {
            commit(
              'dossier/updateDossierTaskInDossier',
              response.data.dossierTask
            )
            commit('dossier/setSelectedDossierTask', response.data.dossierTask)
          }
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await commit('setErrors', reason)
      })
  },

  async updateDossierTaskStatus({ commit, state }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        UpdateTaskDossierStatusController[
          '/api/task-dossier/update-status/{task_dossier}'
        ].put(
          { task_dossier: payload.id },
          { query: { new_status: payload.new_status } }
        )
      )
      .then((response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
          if (payload.isItemTask) {
            commit('setDossier', response.data.dossier)
          } else {
            commit('setDossier', response.data.dossier)
            if (state.selectedDossierTask) {
              if (
                state.selectedDossierTask.parent_type === 'App\\Models\\Dossier'
              ) {
                commit(
                  'setSelectedDossierTask',
                  response.data.dossier.dossier_tasks.find(
                    (dossier_task) =>
                      dossier_task.id === state.selectedDossierTask.id
                  )
                )
              } else if (
                state.selectedDossierTask.parent_type === 'App\\Models\\Event'
              ) {
                commit(
                  'setSelectedDossierTask',
                  response.data.dossier.events
                    .find(
                      (event) =>
                        event.id === state.selectedDossierTask.parent_id
                    )
                    ?.dossier_tasks.find(
                      (dossier_task) =>
                        dossier_task.id === state.selectedDossierTask.id
                    )
                )
              }
            }
          }
        }
      })
      .catch((reason) => {
        console.error('updateDossierTaskStatus', reason)
      })
  }

  // #endregion
}
